import { render } from "./DraftBookingFlow_baseline.vue?vue&type=template&id=52c94519&scoped=true"
import script from "./DraftBookingFlow_baseline.vue?vue&type=script&lang=js"
export * from "./DraftBookingFlow_baseline.vue?vue&type=script&lang=js"

import "./DraftBookingFlow_baseline.vue?vue&type=style&index=0&id=52c94519&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c94519"]])

export default __exports__